// extracted by mini-css-extract-plugin
module.exports = {"root":"FormActions__root___SDe36","box":"FormActions__box___OBPe5"};